import NotFoundNoticeModal from './NotFoundNoticeModal';

export default NotFoundNoticeModal;
